export const prettyMoney = (amount: number): string => {
  return amount.toLocaleString("en-US", {
    style: "currency",
    currency: "USD"
  });
};

export const padNum = (
  num: number,
  padLen: number,
  padChar?: string
): string => {
  const pad = new Array(1 + padLen).join(padChar || "0");
  return (pad + num).slice(-pad.length);
};

export const pickRandom = (array: any[]): any => {
  return array[Math.floor(Math.random() * array.length)];
};
